import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Avatar, Button } from "@mui/material";
import BioData from "./BioData";
import BankDetails from "./BankDetails";
import Institute from "./Institute";
import Scholarship from "./Scholarship";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import UpcomingIcon from '@mui/icons-material/Upcoming';
import BackupIcon from "@mui/icons-material/Backup";
import SchoolIcon from "@mui/icons-material/School";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import GetPersonData from "../../../../context/GetPersonData";
import { ContextData } from "../../../../context/Context";
import Documents from "./Documents";
import InfinityLoader from "../../pages/InfinityLoader";
import InnerLoarder from "../../../../routes/InnerLoarder";
import { Getrequest, Postrequest, Putrequest } from "../../../../context/AxiosRequest";
import { toast } from "react-toastify";
import LoanApplication from "./LoanApplication";
import SendRejectDocumentMssg from "./SendRejectDocumentMssg";
import baseUrl from "../../../../BaseURL";

export default function ApplicantProfileTabs(props) {



  const [value, setValue] = React.useState("1");
  const [personData, setPersonData] = React.useState(null);
  const {UserTokens,GlobalLoader,accesstoken} = React.useContext(ContextData)
  const [Getloan_category,setGetloan_category] = React.useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };



  

  React.useEffect(() => {
   // setOpenLoader(true);
    setPersonData("fetching")
    GetPersonData(props.usertoken,UserTokens).then((data) => {
      if (data !== null) {
        setPersonData(data);
      } 
     // setOpenLoader(false);
    }); 
  },[props.usertoken,GlobalLoader]);



  React.useEffect(() => {
  
      const fetchPersonData = async () => {
  
           
          const loanData = await Getrequest(`/auth/get_loan_data/${props.usertoken}`,accesstoken)
              console.log(props.usertoken ?? "no token");
          // Safely access loanrequest[0] using optional chaining and provide a fallback
          setGetloan_category(loanData?.loanrequest?.[0]?.loan_category ?? null);
   
      } 
  
       fetchPersonData();
   
    }, [props.usertoken, accesstoken]);


   const HandleSelect = (selecttype,token)=>{
                   
                 const data = {
                  selecttype,
                  user_token : token
                 }

                async function FetchData() {
                  
                    const response = await Putrequest("/auth/select_applicant",data,accesstoken)
                    toast.success(response)

                }      

                FetchData()
        
   }


   if(!personData){
       return <h1 className="text-center text-2xl font-bold">Select Applicant to Display</h1>
   }




   if(personData === "fetching"){
    return <div className="h-full">
      <h1 className="text-center text-2xl font-bold">Getting Applicant Data</h1>
      <div className="w-full h-full flex justify-center items-center">
       <div className="w-96">
       <InnerLoarder />
       <p className='text-center font-extrabold text-xs'>Powered By MastermindTech</p>
       </div>

      </div>
    </div>
}

  return (
    <Box sx={{ width: "100%", typography: "body1" , position:"relative"}}>
      {/* Profile preview section */}
      <div className="absolute w-full bg-blue-950">
        <p className="text-center text-white"> <span>Applicant ID : {personData.applicant_credentials[0].s_i_d}</span></p>
      </div>
      
      <div className="flex justify-between items-center w-full p-3 font-mono">
        <div className="preview-con flex  w-full p-3">
          <div className={props.sty === "sty" ? "w-1/6" : "w-1/6"}>
            <Avatar
              alt="Remy Sharp"
              src={`${baseUrl}/get_photo/${personData && personData.bio_data[0].picture}`} 
              sx={{ width: 150, height: 150 }}
            />
             
          </div>

          <div className=" w-3/6 ">
             
            <p>
              <b>Name:</b> <span>{personData && personData.bio_data[0].fname + " " + personData.bio_data[0].lname}</span>
            </p>
            <p>
              <b>Email:</b> <span>{personData && personData.sign_up[0].email}</span>
            </p>
            <p>
              <b>Institution:</b> <span>{personData && 
               <>
               {
                  personData.edu_data[0].university  ?  (personData.edu_data[0].university === "OTHER" ? personData.edu_data[0].manual_university : personData.edu_data[0].university) :  <span className="text-red-900 ">Not Provided</span>
               }
            </>
             }</span>
            </p>
            <p>
              <b>Matric No:</b> <span>{personData && <>
                  {
                    personData.edu_data[0].matric_num  ?   personData.edu_data[0].matric_num :  <span className="text-red-900 ">Not Provided</span>
                  }
               </>}</span>
            </p>
            <p>
              <b>Date Of Birth:</b> <span>{personData && <>
                  {
                    personData.bio_data[0].d_o_b  ?   personData.bio_data[0].d_o_b.split("-").reverse().join("-") :  <span className="text-red-900 ">Not Provided</span>
                  }
               </>}</span>
            </p> 
            <p>
              <b>Age:</b> <span>{personData && <>
                  {
                    personData.bio_data[0].d_o_b  ?  (new Date().getFullYear() - new Date(personData.bio_data[0].d_o_b).getFullYear()):  <span className="text-red-900 ">Not Provided</span>
                  }
               </>}</span>
            </p> 
            {
             
             <p className="bg-green-900 text-center text-white p-2 capitalize">
             {Getloan_category} Application
            </p> 
            }
            <p className="bg-red-700 text-white font-bold text-center">
              {
                Getloan_category === "studentloan" &&
                <span>{ personData.bio_data[0].d_o_b  &&  (new Date().getFullYear() - new Date(personData.bio_data[0].d_o_b).getFullYear()) > 30 &&  <span> 
                   This applicant pass the max age limit for student loan kindly return this application. But don't forget to tell them the reason through mail message
                  </span>}</span> 
              }
            </p>
          </div>

          <div>
            <SendRejectDocumentMssg from="applicantProfile" mssgData={{
              sender_token: UserTokens,
              receiver_token: personData && personData.bio_data[0].user_token
            }} />
          </div>
        </div>

       {/*  {props.sty !== "sty" && <div className="buttons flex gap-2 h-8">
          <Button onClick={()=>HandleSelect("selected_for_award",personData && personData.edu_data[0].user_token)} variant="contained">Select</Button>
          <Button onClick={()=> HandleSelect("rejected_for_award",personData && personData.edu_data[0].user_token)} variant="contained" color="error">
            Reject
          </Button>
        </div> } */}

        
      </div>

      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} sx={{ overflowX:"auto"}} aria-label="lab API tabs example">
            <Tab
              label="Bio Data"u
              value="1"
              icon={<FolderSharedIcon />}
              iconPosition="start"
            />
            {
              props.from !== "bankreviewer" &&
            <Tab
              label="Bank Details"
              value="2"
              icon={<AccountBalanceIcon />}
              iconPosition="start"
            />
            }
            <Tab
              label="Documents"
              value="3"
              icon={<BackupIcon />}
              iconPosition="start"
             
            />
              {
              props.from !== "bankreviewer" &&
            <Tab
              label="Institution"
              value="4"
              icon={<SchoolIcon />}
              iconPosition="start"
            />
            }
           
      
            {
              props.applicationType === "scholarship" &&
            <Tab
              label="Scholarship Applied"
              value="5"
              icon={<PublishedWithChangesIcon />}
              iconPosition="start"
            />
            }

            {
              props.applicationType === "loan" &&
           
              <Tab
               label="Loan Application"
                value="5"
                icon={<PublishedWithChangesIcon />}
                iconPosition="start"
              />    
        
            
            }

            {/* 
            
           
            
            
           
            
            
            
            */}



            
          </TabList>
        </Box>
        
        <TabPanel value="1">
          <BioData 
          bio_data={personData !== null && personData.bio_data[0]}
          edu_data={personData !== null && personData.edu_data[0]}
          demography_data ={personData !== null && personData.demography_data[0]}
          parent_data = {personData !== null && personData.parent_data[0]}
          sign_up = {personData !== null && personData.sign_up[0]}
          
          />
        </TabPanel>
        <TabPanel value="2"> 
          <BankDetails data={personData !== null && personData.bank_details_data[0]} />
        </TabPanel>
        <TabPanel value="3">
           <Documents loanRequest={Getloan_category}  setReload={props.setReload} from={props.from} email={personData !== null && personData.sign_up[0].email} usertoken={personData !== null && personData.edu_data[0].user_token}  data={personData !== null && personData.applicant_doc_data} />
        </TabPanel>
        <TabPanel value="4">
          <Institute data={personData !== null && personData.edu_data[0]} applicationType={props.applicationType} />
        </TabPanel>

          {
             props.applicationType === "scholarship" &&
        <TabPanel value="5">
          <Scholarship 
            data={personData !== null && personData.apply_scholarship_data}
            qualification={personData !== null && personData.edu_data[0].applying_for_type}
          />
        </TabPanel>
          }


          {
             props.applicationType === "loan" &&
        <TabPanel value="5">
          <LoanApplication 
           token = {personData !== null && personData.edu_data[0].user_token}
           from={props.from}
           typeForUser={props.typeForUser}
          />
        </TabPanel>
          }
       

       {/*  <TabPanel value="7">
          <Scholarship 
            data={personData !== null && personData.sponsor_identification_data}
            qualification={personData !== null && personData.edu_data[0].applying_for_type}
          />
        </TabPanel>

        <TabPanel value="8">
          <Scholarship 
            data={personData !== null && personData.spouse_details_data}
            qualification={personData !== null && personData.edu_data[0].applying_for_type}
          />
        </TabPanel>

        <TabPanel value="9">
          <Scholarship 
            data={personData !== null && personData.residential_address_data}
            qualification={personData !== null && personData.edu_data[0].applying_for_type}
          />
        </TabPanel>

        <TabPanel value="10">
          <Scholarship 
            data={personData !== null && personData.employment_details_data}
            qualification={personData !== null && personData.edu_data[0].applying_for_type}
          />
        </TabPanel>

        <TabPanel value="11">
          <Scholarship 
            data={personData !== null && personData.salary_bank_details_data}
            qualification={personData !== null && personData.edu_data[0].applying_for_type}
          />
        </TabPanel>

        <TabPanel value="12">
          <Scholarship 
            data={personData !== null && personData.personal_reference_data}
            qualification={personData !== null && personData.edu_data[0].applying_for_type}
          />
        </TabPanel>

        <TabPanel value="13">
          <Scholarship 
            data={personData !== null && personData.guarantors_details_data}
            qualification={personData !== null && personData.edu_data[0].applying_for_type}
          />
        </TabPanel> */}
      </TabContext>
    </Box>
  );
}
